var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[_c('v-slide-x-transition',{attrs:{"mode":"out-in","appear":""}},[_c('ClientReferalList')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }